/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import { Field } from 'react-final-form';

import { isEmpty } from 'utils/lodash';

import DadataComponent from './DadataComponent';
import { PTField } from '../propTypes';

const DadataField = (props) => {
  const { validate, required } = props;

  const validateField = useMemo(() => {
    if (required && isEmpty(validate)) {
      return (value) => isEmpty(value) && 'Обязательное поле';
    }

    return validate;
  }, [validate, required]);

  return <Field {...props} validate={validateField} component={DadataComponent} />;
};

DadataField.propTypes = {
  ...DadataComponent.propTypes,
  ...PTField,
};

export default DadataField;
